import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./SystemUsersUIHelpers";

const SystemUsersUIContext = createContext();

export function useSystemUsersUIContext() {
  return useContext(SystemUsersUIContext);
}

export const SystemUsersUIConsumer = SystemUsersUIContext.Consumer;

export function SystemUsersUIProvider({ systemUsersUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewSystemUserPage: systemUsersUIEvents.openNewSystemUserPage,
    openEditSystemUserPage: systemUsersUIEvents.openEditSystemUserPage,
  };

  return (
    <SystemUsersUIContext.Provider value={value}>
      {children}
    </SystemUsersUIContext.Provider>
  );
}